import React from 'react';
import ForgotPasswordForm from '../../components/ForgotPasswordForm';

const Login: React.FC = () => {
  return (
    <ForgotPasswordForm />
  );
};

export default Login;